
export var global = { env: { flags: {} } }

export const UI_ACTIONS_RESULT_GRID = "ui.actions-in-result-grid";
export const UI_ML_EXPLAIN = "ui.ml-explain"